<template>
  <div>
    <b-col lg="12" class="text-left">
        <router-link class="" :to="{ name: 'Metas' }">
          <b-button pill variant="info" class="col-lg-3" >
            بازگشت
          </b-button
          >
        </router-link>
    </b-col>

    <b-table
        v-bind="tableAttributes"
        :fields="fields"
        :items="metas"
        class="mt-2">

      <template #cell(name)="data">
        {{ data.item.name }}
      </template>
      <template #cell(meta_key)="data">
        {{ data.item.meta_key }}
      </template>
      <template #cell(metaable_type)="data">
        {{ meta_types[data.item.metaable_type] }}
      </template>
      <template #cell(function)="data">
        {{ data.item.function }}

        <b-icon icon="arrow-clockwise" class="ml-4" font-scale="1.5" @click="restoreMeta(data.item)"/>

      </template>
    </b-table>
  </div>
</template>

<script>
import {tableAttributes} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";
import {mapGetters} from "vuex";
import {meta_types} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Meta'

export default {
  name: "tableItems",

  data() {
    return {
      tableAttributes: {...tableAttributes, ...{responsive: "xl"}},
      fields: [
        {key: "name", label: "عنوان"},
        {key: "meta_key", label: "اولویت"},
        {key: "metaable_type", label: "وضعیت"},
        {key: "function", label: "عملیات"},
      ],
      meta_types,
    };
  },
  computed: {
    ...mapGetters({
      metas: 'Meta/getTrash' ,

    })
  },

  mounted() {
    this.$store.dispatch('Meta/setTrash')

  },
  methods:{
    restoreMeta(meta) {
      if (confirm('آیا از بازگردانی این محصول اطمینان دارید؟')) {
        this.$store.dispatch("Meta/restoreMeta", meta);
      }
    },

  },

};
</script>